"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _button = _interopRequireDefault(require("./button"));
var _node = _interopRequireDefault(require("./node"));
const Skeleton = props => {
  const {
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style
  } = props;
  const baseClassName = "".concat(prefixClass, "-listEmpty");
  return null;
};
Skeleton.Button = _button.default;
Skeleton.Node = _node.default;
var _default = exports.default = Skeleton;